(function () {
    'use strict';

    // @ngInject
    Services.Firebase = function ($window) {
        return $window.firebase;
    };

}());
